<template>
  <div>
    <h4 class="text-lg font-bold uppercase tracking-wider text-gray-800 mb-4 pb-2 border-b border-gray-200">
      {{ $t("useful_links") }}
    </h4>

    <ul class="space-y-2">
      <li v-if="currentPdf">
        <a
          :href="currentPdf"
          :download="currentPdf.split('/').pop()"
          class="text-gray-600 hover:text-[#009d66] transition-colors text-sm font-medium flex items-center gap-1"
        >
          <i class="fa fa-file-pdf-o mr-1"></i>
          {{ $t('download_b2c_pdf', 'SEPA Direct Debit Mandate (PDF)') }}
        </a>
      </li>
      <li v-if="isPrepaymentAccount">
        <a
          target="_blank"
          href="/attestation-d-identite-bancaire-fortis-be-72-2500-0746-2116-1.pdf"
          class="text-gray-600 hover:text-[#009d66] transition-colors text-sm font-medium flex items-center gap-1"
        >
          <i class="fa fa-file-pdf-o mr-1"></i>
          {{ $t('prepayment_bank_details', 'Prepayment – Bank account details (RIB)') }}
        </a>
      </li>
      <li v-if="isFactoringAccount">
        <a
          target="_blank"
          href="/bnp-facto-2891.pdf"
          class="text-gray-600 hover:text-[#009d66] transition-colors text-sm font-medium flex items-center gap-1"
        >
          <i class="fa fa-file-pdf-o mr-1"></i>
          {{ $t('factoring_bank_details', 'Factoring – Bank account confirmation') }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { useUtilityStore } from '~/store/UtililityStore'
import { useUserStore } from '~/store/UserStore'

const utilityStore = useUtilityStore()

const selectedLanguage = computed(() => utilityStore.selectedLanguage)

// Logged-in only: prepayment ("Virement anticipé") clients get the CLD bank identity
// statement (RIB); factoring clients get the BNP Paribas Fortis Factor account confirmation.
const userStore = useUserStore()
const isPrepaymentAccount = computed(
  () =>
    userStore.isAuthenticated &&
    (userStore.cldUser?.cCat1 || '').trim().toLowerCase() === 'virement anticipé'
)
const isFactoringAccount = computed(
  () => userStore.isAuthenticated && !!userStore.cldUser?.factoring
)

const b2cPdf = {
  fr_BE: "/BLANCO_B2C_FR.pdf",
  en_GB: "/BLANCO_B2C_FR.pdf",
  nl_BE: "/BLANCO_B2C_FR.pdf",
  de_DE: "/BLANCO_B2C_FR.pdf"
}

const currentPdf = computed(() => b2cPdf[selectedLanguage.value] || b2cPdf["en_GB"])
</script>